{
  "overridesEnabledBadgeLabel": "覆盖于",
  "releaseBadgeAlpha": "Alpha",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "开发",
  "releaseBadgePoc": "POC"
}
